import {createContext} from 'react';

import type {Meeting} from '../services/InfinityClient.service';

export const MeetingContext = createContext<Meeting | undefined>(undefined);
